import { Box, Container, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import theme from "../theme/theme";

const Content2 = () => {
  const companyValues = [
    {
      name: "Integrity",
      img: "/integrity.webp",
      description:
        "We ensure a clear and transparent visa application process with no hidden costs, providing clients with complete clarity and trust.",
    },
    {
      name: "Excellence",
      img: "/excellence.webp",
      description:
        "We are committed to quality and innovation, consistently exceeding expectations and setting industry standards.",
    },
    {
      name: "Growth",
      img: "/Growth.webp",
      description:
        "We embrace continuous improvement and market expansion, driving long-term success and sustainability.",
    },
  ];

  return (
    <Container>
      <Box>
        <Grid container spacing={2}>
          {companyValues.map((value, index) => (
            <Grid key={index} item xs={12} md={4} lg={4}>
              <motion.div
                initial={{ opacity: 0, y: 50, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: false, amount: 0.2 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Box sx={{ padding: "20px", textAlign: "center" }}>
                  <Box
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      height: "70px",
                      width: "70px",
                      padding: "20px",
                      borderRadius: "50%",
                      margin: "auto",
                      border: "6px solid",
                      borderImage: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light}, ${theme.palette.primary.dark}) 1`,
                    }}
                  >
                    <img
                      src={value.img}
                      alt={value.name}
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{ fontSize: "1.5rem", color: theme.palette.primary.main ,
                      fontFamily:'Emirates',


                    }}
                  >
                    {value.name}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: "1.1rem", color: "gray",
                      fontFamily:'Emirates',

                    
                     }}
                  >
                    {value.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Content2;
